import { useQuery } from '@tanstack/react-query';

import {
	listMyTicketsOptions,
	type MyTicketsResponseView,
} from '@mopla/ticketshop-api';

import { IMyTicket } from '../types';

import { mapMyTicketDto } from './mapMyTicketDto';

interface IUseMyTicketsResult {
	tickets: IMyTicket[];
	isLoading: boolean;
	error: Error | null;
}

export const useMyTickets = (): IUseMyTicketsResult => {
	const { data, isLoading, error } = useQuery({
		...listMyTicketsOptions(),
		refetchOnMount: 'always',
		select: (res: MyTicketsResponseView): IMyTicket[] =>
			(res?.tickets ?? []).map(mapMyTicketDto),
	});

	return { tickets: data ?? [], isLoading, error };
};
